module.exports = __webpack_public_path__ + "static/media/16_before.3897f868.jpg";